import base from "../middlewares/interceptors";
import {
  getPaginatedAuthTagsListUrl,
  getUserAuthTagUrl,
  createAuthTagUrl,
  updateAuthTagUrl,
  deleteAuthTagUrl,
  getActiveAuthTagUrl,
} from "./constants";

// Get paginated tags list
export const getPaginatedUserAuthTagList = async ({
  page,
  pSize,
  searchTerm,
  signal,
  isActive = "true",
}: any) => {
  try {
    let url = `${getPaginatedAuthTagsListUrl}?page=${page}&size=${pSize}`;

    // Add is_active parameter if not "all"
    if (isActive !== "all") {
      const isActiveBoolean = isActive === "true" ? "true" : "false";
      url += `&is_active=${isActiveBoolean}`;
    }

    // Add search parameter if searchTerm is provided and has minimum 3 characters
    if (searchTerm && searchTerm.trim().length >= 3) {
      url += `&name=${encodeURIComponent(searchTerm.trim())}`;
    }

    const response = await base.get(url, {
      signal, // Add abort signal for request cancellation
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching paginated tags list:", error);
    throw error;
  }
};
export const getAllAuthTagList = async () => {
  try {
    const response = await base.get(`${getActiveAuthTagUrl}/all`);
    return response.data;
  } catch (error) {
    console.error("Error fetching paginated auth tags list:", error);
    throw error;
  }
};
// Get active auth tags - optionally filtered by specific IDs
export const getActiveAuthTagList = async (authTagIds?: number[]) => {
  try {
    let url = getActiveAuthTagUrl;

    // If specific auth tag IDs are provided, add them as query parameters
    if (authTagIds && authTagIds.length > 0) {
      const idsParam = authTagIds.join(",");
      url = `${getActiveAuthTagUrl}?auth_tag_filter_ids=${encodeURIComponent(
        idsParam
      )}`;
    }
    const response = await base.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching active auth tags:", error);
    throw error;
  }
};

// Get tag by ID
export const getUserAuthTagById = async (id: string | number) => {
  try {
    const response = await base.get(`${getUserAuthTagUrl}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching tag by ID:", error);
    throw error;
  }
};

// Create new tag
export const createUserAuthTag = async (payload: {
  name: string;
  description: string;
}) => {
  try {
    const response = await base.post(createAuthTagUrl, payload);
    return response.data;
  } catch (error) {
    console.error("Error creating tag:", error);
    throw error;
  }
};

// Update tag
export const updateUserAuthTag = async (
  id: string | number,
  payload: { name: string; description: string }
) => {
  try {
    const response = await base.put(`${updateAuthTagUrl}/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating tag:", error);
    throw error;
  }
};

// Delete tag
export const deleteUserAuthTag = async (id: string | number) => {
  try {
    const response = await base.delete(`${deleteAuthTagUrl}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting tag:", error);
    throw error;
  }
};

// Reactivate tag
export const reactivateAuthTag = async (id: string | number) => {
  try {
    const response = await base.put(
      `${getUserAuthTagUrl}/${id}/reactivate`,
      {}
    );
    return response.data;
  } catch (error) {
    console.error("Error reactivating tag:", error);
    throw error;
  }
};
